/* istanbul ignore file */
import { useToastNotification } from './ToastNotificationContext';

export default useToastNotification;
